<script setup lang="ts">
import FollowUpTrackingBoard from "@/components/visit-workbench/FollowUpTrackingBoard.vue";
import FollowUpSchedulingQueue from "@/components/visit-workbench/FollowUpSchedulingQueue.vue";

definePage({
  meta: {
    navActiveLink: "healthcare-visits",
    permissionKey: "page.healthcare.visits",
  },
});

const { t } = useI18n();
const tab = ref<"tracking" | "scheduling">("tracking");
</script>

<template>
  <div class="follow-ups-page">
    <VTabs
      v-model="tab"
      class="mb-4"
      color="primary"
    >
      <VTab value="tracking" prepend-icon="tabler-checkup-list">
        {{ t("alkokh.healthcare.followUps.tabs.tracking") }}
      </VTab>
      <VTab value="scheduling" prepend-icon="tabler-calendar-plus">
        {{ t("alkokh.healthcare.followUps.tabs.scheduling") }}
      </VTab>
    </VTabs>

    <VWindow v-model="tab">
      <VWindowItem value="tracking">
        <FollowUpTrackingBoard />
      </VWindowItem>
      <VWindowItem value="scheduling">
        <FollowUpSchedulingQueue />
      </VWindowItem>
    </VWindow>
  </div>
</template>
